import { useHistory } from "react-router-dom";
import { type AssetModelBillingAnomalyModel } from "@doitintl/cmp-models";
import { type ModelRef } from "@doitintl/models-any";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Box, IconButton, ListItem, Stack, Typography } from "@mui/material";

import { getDatetimeAndDiffFromTimestamp } from "../../../../utils/time";
import { anomalyFeedbackReasonsLabels } from "../../../AnomalyDetection/CostAnomalyDetails/consts";

type AcknolagedAnomalyRowProps = {
  anomaly: ModelRef<AssetModelBillingAnomalyModel>;
  hideDivider: boolean;
};

export const AcknolagedAnomalyRow = ({ anomaly, hideDivider }: AcknolagedAnomalyRowProps) => {
  const history = useHistory();

  const customerFeedback = anomaly.customerFeedback;

  return (
    <ListItem
      divider
      sx={{ py: 1, borderBottom: hideDivider ? "none" : "1px solid", borderColor: "divider", cursor: "pointer" }}
      onClick={() => {
        history.push(`./monitor/cost-anomalies/${anomaly.ref.path.split("/")[1]}/${anomaly.metadata.alert_id}`);
      }}
    >
      <Stack direction="row" alignItems="center" width="100%" spacing={2}>
        <Stack sx={{ width: "1.5rem" }}>
          <CheckCircleOutlineIcon sx={{ color: "success.light" }} />
        </Stack>
        <Box sx={{ minWidth: 0, width: "75%", flex: 1 }}>
          <Typography variant="body2" noWrap sx={{ textOverflow: "ellipsis", overflow: "hidden", display: "block" }}>
            {anomaly.metadata.sku_name}
          </Typography>
          {customerFeedback && (
            <Typography
              variant="caption"
              color="text.secondary"
              noWrap
              sx={{ textOverflow: "ellipsis", overflow: "hidden", display: "block" }}
            >
              Acknowledged as {anomalyFeedbackReasonsLabels[customerFeedback.reason]?.toLowerCase()}{" "}
              {getDatetimeAndDiffFromTimestamp(customerFeedback.updatedAt).timeAgo} by {customerFeedback.updatedBy}
            </Typography>
          )}
        </Box>
        <Stack direction="row" alignItems="center" width="1.5rem">
          <IconButton size="small">
            <ChevronRightIcon fontSize="inherit" />
          </IconButton>
        </Stack>
      </Stack>
    </ListItem>
  );
};
